import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["NDrawer"], {
    class: "Drawer",
    show: $setup.active,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (($setup.active) = $event)),
    width: 800,
    placement: $setup.props.placement,
    "on-update:show": $setup.clearDrawer
  }, {
    default: _withCtx(() => [
      _createVNode($setup["NDrawerContent"], { class: "Drawer__content" }, {
        default: _withCtx(() => [
          ($setup.drawerHistoryLength === 1)
            ? (_openBlock(), _createBlock($setup["NIcon"], {
                key: 0,
                class: "Drawer__exitButton",
                ref: "DrawerExitButton",
                size: "24",
                onClick: $setup.clearDrawer
              }, {
                default: _withCtx(() => [
                  _createVNode($setup["CloseSharp"])
                ]),
                _: 1
              }, 512))
            : _createCommentVNode("", true),
          ($setup.drawerHistoryLength > 1)
            ? (_openBlock(), _createBlock($setup["NIcon"], {
                key: 1,
                class: "Drawer__backButton",
                ref: "DrawerBackButton",
                size: "24",
                onClick: $setup.goBack
              }, {
                default: _withCtx(() => [
                  _createVNode($setup["ArrowBackSharp"])
                ]),
                _: 1
              }, 512))
            : _createCommentVNode("", true),
          (_openBlock(), _createBlock(_resolveDynamicComponent($setup.component), { ref: "DrawerContent" }, null, 512))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show", "placement"]))
}